export default "__VITE_ASSET__txkKehTq__"